import { createFileRoute } from "@tanstack/react-router";
import { HasNoPermissionPage } from "@/components/ErrorPages/HasNoPermissionPage";

export const Route = createFileRoute("/403")({
  component: () => <HasNoPermissionPage />,
});
